import { useState, useEffect } from "react";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { Button } from "~/components/ui/button";

export function ThemeToggle(props: { className?: string }) {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.classList.toggle("dark", savedTheme === "dark");
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.classList.toggle("dark", newTheme === "dark");
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={props.className}
    >
      {theme === "light" ? <IconMoon size={20} /> : <IconSun size={20} />}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
